import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { get, put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "notifications";

export const getMemberNotificationsBySSNAndGroupNumber = async (params: any) => {
	try {
		const endpoint = `${initialRoute}/member`;
		const token = localStorage.getItem("@jwt_member");
		// console.log("Notification token", token);
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			params
		);

		// console.log("MemberNotification", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		// else {
		// 	throw new Error();
		// }
	} catch (error: any) {
		// console.log("Error_notification", error);
		if (error.response?.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			//alert(message);
		} else if (error.response?.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			//alert(message);
		} else {
			throw error;
		}
	}
};

export const setAllNotificationsAsOldBySSNAndGroupNumber = async () => {
	try {
		const endpoint = `${initialRoute}/member`;
		const token = localStorage.getItem("@jwt_member");
		const response = await put(
			endpoint,
			{},
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			}
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const getMemberNotificationCount = async () => {
	try {
		const endpoint = `${initialRoute}/member-count`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
